import styled, { css } from 'styled-components';
import { Row } from '@blueprism/ui-core';

export const StyledDetailsText = styled(Row)`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.bold};
  `}
`;
